interface CreditBalanceProps {
  credits: {
    balance: number;
    total_earned: number;
    total_spent: number;
  };
}

export default function CreditBalance({ credits }: CreditBalanceProps) {
  return (
    <div className="glass-card rounded-xl p-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
        Credit Balance
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-white/50 dark:bg-slate-800/50 rounded-lg p-4">
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">Current Balance</p>
          <p className="text-3xl font-bold text-primary-600 dark:text-primary-400">
            {credits.balance.toLocaleString()}
          </p>
        </div>
        <div className="bg-white/50 dark:bg-slate-800/50 rounded-lg p-4">
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">Total Earned</p>
          <p className="text-3xl font-bold text-green-600 dark:text-green-400">
            {credits.total_earned.toLocaleString()}
          </p>
        </div>
        <div className="bg-white/50 dark:bg-slate-800/50 rounded-lg p-4">
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">Total Spent</p>
          <p className="text-3xl font-bold text-gray-600 dark:text-gray-400">
            {credits.total_spent.toLocaleString()}
          </p>
        </div>
      </div>
      <p className="mt-4 text-sm text-gray-600 dark:text-gray-400">
        💡 1 credit = 1 image alt text generation
      </p>
    </div>
  );
}

